<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <rect x="4.5" y="2.4" width="2.4" height="11.2" rx="1.2" fill="black"></rect>
  <rect x="9.1" y="2.4" width="2.4" height="11.2" rx="1.2" fill="black"></rect>
</svg>